import { Balance } from "#src/utils/calculateInvoiceItemBalance.ts";
import {
  BetaAccessType,
  InvoiceStatus,
  StripeType,
} from "#types/code-generator.ts";
import calculateInvoiceBalance from "../utils/calculateInvoiceBalance.ts";
import { InvoiceItemModel } from "./InvoiceItemModel.ts";
import UserModel from "./UserModel.ts";

export const isInvoice = (item): item is InvoiceModel => {
  return (item && item.invoiceItems) || item instanceof InvoiceModel;
};

export default class InvoiceModel {
  automated: boolean;
  createdAt: Date;
  file: {
    id: string;
    url: string;
    name: string;
  };
  id: string;
  invoiceItems: InvoiceItemModel[] = [];
  invoiceDate: Date;
  noPayment: boolean;
  organization: {
    id: string;
    betaAccess: BetaAccessType[];
    subdomain: string;
    title: string;
    stripe: StripeType;
    commissionSettings: {
      amount: number;
      startDate: Date;
      endDate: Date;
      user: {
        id: string;
        firstName: string;
        lastName: string;
      };
    }[];
    departments: {
      id: string;
      balanceAccountId: string;
      stripeExpressAccountId: string;
      default: boolean;
      email: string;
    }[];
    timezone: string;
    paymentProcessing: {
      enableAch: boolean;
      achCredit: number;
      achCreditBillingCategory: {
        id: string;
      };
    };
    phone: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    logo: {
      url: string;
    };
    meetTeamAbbreviation: string;
    stripeAccountId?: string;
    stripeExpressAccountId?: string;
    email: string;
    balanceAccounts: {
      id: string;
      balanceAccountId: string;
      default: boolean;
    }[];
    owner: {
      email: string;
    };
    stripeFee: number;
  };
  receipt: {
    id: string;
    url: string;
    name: string;
  };
  serviceRunId: string;
  status: InvoiceStatus;
  updatedAt: Date;
  user: UserModel;

  constructor(data: InvoiceModel | {}) {
    Object.assign(this, data);
  }

  getTotals(): Balance {
    return calculateInvoiceBalance(this);
  }

  getBalance() {
    const totals = this.getTotals();
    const balance = totals.balance;

    return parseInt(balance.toString());
  }
}
